import { defineComponent as r, computed as l, openBlock as i, createElementBlock as a, createElementVNode as e, toDisplayString as n, createCommentVNode as h, normalizeStyle as _ } from "vue";
const f = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "5168098b-0d99-481a-a076-4cdd90b44fda" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#5168098b-0d99-481a-a076-4cdd90b44fda)" }, p = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "M0 0h512v111.3l-85.3 143.1L512 400.7V512H0V400.7l87-149L0 111.3z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 111.3h512V167l-41 84.7 41 93.3v55.7H0V345l44.2-86.6L0 167z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#a2001d",
  d: "M0 167h512v178H0z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m256 167 22.1 68h71.5l-57.8 42 22 68-57.8-42-57.9 42 22.1-68-57.8-42h71.5z"
}, null, -1), w = { fill: "none" }, y = ["r"], B = /* @__PURE__ */ r({
  __name: "sr",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(d) {
    const t = d, o = l(() => 512 + 2 * t.strokeWidth), s = l(() => -t.strokeWidth), c = l(() => 256 + t.strokeWidth / 2);
    return (z, V) => (i(), a("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${o.value} ${o.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (i(), a("title", p, n(t.flagName), 1)) : h("", !0),
        k,
        v,
        g,
        x
      ]),
      e("g", w, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: c.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, y)
      ])
    ], 8, f));
  }
});
export {
  B as default
};
//# sourceMappingURL=sr-1dbe4317.js.map
